<template>
    <div @mouseover="startUpdateRole"
         @mouseleave="stopUpdateRole"
         v-touch:start="startUpdateRole"
         v-touch:end="stopUpdateRole"
         v-touch:tap="go"
         :class="{ 'pointer' : person.is_published}"
    >
        <span v-if="person.alias">{{ person.alias}}</span>
        <span v-else>{{ person.firstname }} {{ person.lastname }}</span>
        <div class="subitem"><span class="nationality">{{ nationalities }} </span><span class="job">{{role ? role : '&nbsp;'}}</span></div>
    </div>

</template>

<script>

    export default {
        name: "Person",
        components: {
        },
        props: {
            person : null
        },
        data: () => {
            return {
                roles: null,
                role: '',
                index: 0,
                roleInterval: null
            }
        },
        mounted() {
            if (this.person.roles && this.person.activities.length) {
                this.roles = this.person.roles
                if (this.person.activities > 0 && this.person.activities.length) {
                    this.roles = this.roles.concat(this.person.activities);
                }
                this.role = this.roles[this.index];
            }
        },
        computed: {
            nationalities () {
                if (this.person.nationalities) {
                    return this.person.nationalities.join(' / ');
                } else {
                    return '&nbsp;'
                }
            },
            getRole() {
                if (this.roles) {
                    this.role = this.roles[this.index];
                }
            }
        },
        watch: {
            index: function() {
                this.role = this.roles[this.index];
            }
        },
        methods: {
            go() {
                if (this.person.is_published) {
                    this.$router.push({name: 'people.view', params: {id: this.person.id, slug: this.person.slug}})
                }
            },
            startUpdateRole() {
                this.stopUpdateRole();
                this.roleInterval = setInterval(() => {
                    this.index = (this.index + 1) % this.roles.length
                }, 800);
            },
            stopUpdateRole() {
                clearInterval(this.roleInterval);
                this.roleInterval = null;
            }
        }
    }
</script>

